<template lang="pug">
.form-step-one.form-step
  .form-step-one-text.title {{ schedulerLocales["step1"] }}
  .form-step-input
    input-title(:title="schedulerLocales['schedulerName']", :required="true")
    q-input.form-step-one-name(:value="name", @input="updateName", filled, no-error-icon, autocomplete="off")
      q-icon.cancel-string-field(name="cancel", v-if="name", @click.stop="resetNameField()")
  .form-step-input
    select-field(
      :full-options-path="store.state.paths['facility']",
      :readonly="false",
      :multiple="false",
      :initialValue="facility ? facility.id : null",
      :optionsParams="{}",
      :showCancel="true",
      :label="schedulerLocales['facility']",
      required,
      @change="updateFacility"
    )
  .form-step-input
    select-field(
      :key="contractSelectKey",
      :full-options-path="store.state.paths['contract']",
      :readonly="contractReadonly",
      :multiple="false",
      :initialValue="contractInitialValue",
      :optionsParams="contractSelectParams",
      :showCancel="true",
      :label="schedulerLocales['contract']",
      @change="onContractChange"
    )
</template>

<script setup>
import { computed, toRefs } from "vue";
import i18n from "@/plugins/vue-i18n";
import selectField from "../../../../shared/general_components/fields/selectField";
import { useStore } from "@/store";
import { currentLocale } from "@/services/useLocales";
import inputTitle from "./inputTitle.vue";

const props = defineProps({
  facility: { type: Object, default: () => null },
  contract: { type: Object, default: () => null },
  name: { type: String, default: () => "" },
});
const emit = defineEmits(["update-facility", "update-contract", "update-name"]);
const store = useStore();

const schedulerLocales = computed(() => i18n["messages"][currentLocale.value]["scheduler"]);

const { facility, contract, name } = toRefs(props);

const contractReadonly = computed(() => !facility.value?.id);
const contractInitialValue = computed(() => contract.value?.id || null);
const contractSelectParams = computed(() => (facility.value?.id ? { facility_id: facility.value.id } : {}));
const contractSelectKey = computed(() => `contract-${facility.value?.id || "empty"}`);

const updateFacility = val => {
  emit("update-facility", val);
};

const onContractChange = val => {
  emit("update-contract", val);
};

const updateName = val => {
  emit("update-name", val);
};

const resetNameField = () => {
  emit("update-name", "");
};
</script>
